
export default (num) => {

    let numString = num.toString();
    if(numString.length > 2){
        numString = numString.substr(-2);
    }

    return numString;
}